import { TemplatePortal, ComponentPortal, DomPortal } from '@angular/cdk/portal';
import { Observable, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';

export type Portal = TemplatePortal | ComponentPortal<any> | DomPortal;

@Injectable({
  providedIn: 'root',
})
export class SidePanelContentService {
  private activePortal$$ = new ReplaySubject<Portal | null>(1);

  setContent(content: Portal) {
    this.activePortal$$.next(content);
  }

  getContent(): Observable<Portal | null> {
    return this.activePortal$$.asObservable();
  }

  clearContent(): void {
    this.activePortal$$.next(null);
  }
}
